import { useLanguage } from "@/hooks/useLanguage";
import { Bot, Building2, Globe, QrCode, Search, ShieldCheck, LineChart } from "lucide-react";

export function TrustBar() {
  const { language } = useLanguage();

  const benefits = {
    fr: [
      { icon: ShieldCheck, label: "Réputation & avis" },
      { icon: Bot, label: "Réponses IA contrôlées" },
      { icon: QrCode, label: "QR code & collecte" },
      { icon: Search, label: "Audit GBP" },
      { icon: LineChart, label: "Visibilité locale" },
      { icon: Building2, label: "Concurrents locaux" },
      { icon: Globe, label: "Pilotage multi-plateforme" },
    ],
    en: [
      { icon: ShieldCheck, label: "Reputation & reviews" },
      { icon: Bot, label: "Controlled AI replies" },
      { icon: QrCode, label: "QR code & collection" },
      { icon: Search, label: "GBP Audit" },
      { icon: LineChart, label: "Local visibility" },
      { icon: Building2, label: "Local competitors" },
      { icon: Globe, label: "Multi-platform control" },
    ],
  };

  const items = benefits[language];
  const duplicatedItems = [...items, ...items, ...items];

  return (
    <div className="w-full overflow-hidden border-y border-border bg-muted/40 py-5">
      <div className="flex items-center animate-scroll-left">
        {duplicatedItems.map((benefit, index) => {
          const IconComponent = benefit.icon;
          return (
            <div key={`${benefit.label}-${index}`} className="flex items-center">
              <div className="flex items-center gap-2.5 px-6">
                <IconComponent size={18} className="text-primary flex-shrink-0" strokeWidth={2.2} />
                <span className="whitespace-nowrap text-sm font-medium text-foreground">{benefit.label}</span>
              </div>
              <span className="mx-2 text-xs text-muted-foreground">•</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
